import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Vendite from './pages/Vendite';
import Cantieri from './pages/Cantieri';
import Dashboard from './pages/Dashboard';
import Contatti from './pages/Contatti';
import VenditeForm from './pages/VenditeForm';
import Budget from './pages/Budget';
import Pagamenti from './pages/Pagamenti';
import Fornitori from './pages/Fornitori';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/uiKit.css';

const Layout = () => (
    <div className="d-flex">
        <Sidebar />
        <div id="main-content" className="flex-grow-1 p-3" style={{ marginLeft: '220px' }}>
            <Outlet />
        </div>
    </div>
);

function App() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/" element={<Cantieri />} />
                <Route path="/dashboard/:id" element={<Dashboard />} />
                <Route path="/dashboard/:id/vendite" element={<Vendite />} />
                <Route path="/dashboard/:id/vendite/aggiungi" element={<VenditeForm />} />
                <Route path="/dashboard/:id/vendite/modifica/:venditaId" element={<VenditeForm />} />
                <Route path="/dashboard/:id/budget" element={<Budget />} />
                <Route path="/dashboard/:id/contatti" element={<Contatti />} />
                <Route path="/dashboard/:id/pagamenti" element={<Pagamenti />} />
                <Route path="/dashboard/:id/fornitori" element={<Fornitori />} />
            </Route>
        </Routes>
    );
}

export default App;
